module.exports = __webpack_public_path__ + "static/calorex-header-greenfoam-lp-49ca6741b9e281c34e563497cd16054b.jpg";